import React, { useEffect, useState } from "react";

import axiosInstance, { handleApiError } from "../../services/axiosService";
import Input from "../../components/FormComponents/Input";
import MultiRadio from "../../components/FormComponents/MultiRadio";
import Button from "../../components/FormComponents/Button";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import { toastSuccess } from "../../utils/toastUtils";

const AddTheme = ({ setThemes, onClose, deviceFilter, css, from }) => {
  const [themeName, setThemeName] = useState("");
  const [device, setDevice] = useState(deviceFilter);
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState({});

  const fetchOrganisations = async () => {
    try {
      const { data } = await axiosInstance.get(`/organisations`);
      setOrganisations(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchOrganisations();
    setDevice(deviceFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceFilter, onClose]);

  const handleDeviceTypeChange = (event) => {
    setDevice(event.target.value);
  };

  const handleSelectChange = (id) => {
    if (id) {
      const org = organisations.find((org) => org.id === id);
      setSelectedOrganisation(org);
    } else {
      setSelectedOrganisation({});
    }
  };

  const addTheme = async () => {
    try {
      const orgId = selectedOrganisation?.id || "";
      const themeConfig = {
        config: {
          css: css || "",
          device: orgId ? `org_${device}` : device
        },
        name: themeName,
        type: "theme",
        org_id: orgId,
        org_name: selectedOrganisation?.name
      };

      const response = await axiosInstance.post(`/screentheme/sysconfigs`, themeConfig);
      const { data, message } = response;

      setThemes((prevThemes) => [...prevThemes, data]);

      toastSuccess(message);
      onClose();
    } catch (error) {
      handleApiError(error?.response?.data?.message || "Failed to add theme");
    }
  };

  const deviceOptions = [
    { name: "Desktop", id: "desktop" },
    { name: "Mobile", id: "mobile" },
    { name: "Tablet", id: "tablet" }
  ];

  return (
    <div className="builder_form">
      <Input label="Enter theme name" value={themeName} onChange={(e) => setThemeName(e.target.value)} />
      <MultiRadio
        options={deviceOptions}
        selectedValue={device}
        onChange={handleDeviceTypeChange}
        label="Select Device"
      />
      {from === "org" && (
        <SingleSelectBox
          selectedData={selectedOrganisation?.id || ""}
          options={organisations || []}
          onChange={(obj) => handleSelectChange(obj.id)}
          placeholder="Select Organization"
          label="Organization"
          isSearch={true}
        />
      )}
      <Button onClick={addTheme}>Add Theme</Button>
    </div>
  );
};

export default AddTheme;
